import React, { Component } from 'react';
import PropTypes from 'prop-types';

import branch from 'client/core/branch';
import SrCtaStepsBlock from 'client/components/SrCtaStepsBlock';

@branch({
  checkAvailabilityByListingId: ['checkAvailabilityByListingId'],
  tours: ['tours'],
  renterProfilesByUserId: ['household', 'renterProfilesByUserId'],
})
class SrCompleteYourProfileBlock extends Component {
  static propTypes = {
    checkAvailabilityByListingId: PropTypes.object.isRequired,
    tours: PropTypes.array.isRequired,
  };

  render() {
    const { tours, checkAvailabilityByListingId } = this.props;

    const steps = [
      {
        text: 'Setup search filters',
        completed: true,
      },
      {
        text: 'Explore your rental matches',
        completed: true,
      },
      {
        text: 'Request a tour or check availability',
        completed: tours.length > 0 || Object.keys(checkAvailabilityByListingId).length > 0,
        linkTo: '/feed',
      },
    ];

    const stepsCompletedCount = steps.filter(({ completed }) => completed).length;

    if (stepsCompletedCount === steps.length) {
      return null;
    }

    return (
      <div className="promptCard blue">
        <SrCtaStepsBlock
          headline={`Complete your profile (${stepsCompletedCount}/${steps.length})`}
          steps={steps}
        />
      </div>
    );
  }
}

SrCompleteYourProfileBlock.displayName = 'SrCompleteYourProfileBlock';

export default SrCompleteYourProfileBlock;
